import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FamilleService } from "../../Services/FamilleService";
import Formulaire from "../Formulaire";
import { ParticipantsIpmService } from "../../Services/ParticipantsIpmService";
import { AdherentsService } from "../../Services/AdherentsService";

import dayjs from "dayjs";
import { Button, message, Tag, Space } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

const EditParticipant = () => {
  const { numcont } = useParams();
  const [participantData, setParticipantData] = useState({});
  const [familleData, setFamilleData] = useState([]);
  const [adherentsList, setAdherentsList] = useState([]);
  const [formCodesoc, setFormCodesoc] = useState();
  const benefService = new FamilleService();
  const participantsIpmService = new ParticipantsIpmService();
  const adherentsService = new AdherentsService();
  const navigate = useNavigate();
  useEffect(() => {
    // Récupérer les détails du participant
    benefService
      .getAllBeneciaire(numcont)
      .then((data) => {
        setFamilleData(data);
      })
      .catch((error) => {
        console.error(
          "Erreur lors de la récupération des détails du participant",
          error
        );
      });

    // Récupérer les ayants droits du participant
    participantsIpmService
      .getOneListParticipant(numcont)
      .then((data) => {
        setParticipantData(data);
      })
      .catch((error) => {
        console.error(
          "Erreur lors de la récupération des ayants droits du participant",
          error
        );
      });

    // Récupérer la liste des adhérents
    adherentsService
      .getAllAdherents()
      .then((data) => {
        console.log("Adhérents chargés:", data);
        setAdherentsList(data);
      })
      .catch((error) => {
        console.error(
          "Erreur lors de la récupération des adhérents",
          error
        );
      });
  }, [numcont]);

  const initialValuesWithMoment = {
    ...participantData,
    etat: participantData.etat,

    datenaiss: participantData.datenaiss
      ? dayjs(participantData.datenaiss)
      : null,
    dateemb: participantData.dateemb ? dayjs(participantData.dateemb) : null,
    datesous: participantData.datesous ? dayjs(participantData.datesous) : null,
    dateres: participantData.dateres ? dayjs(participantData.dateres) : null,
    dateradiation: participantData.dateradiation
      ? dayjs(participantData.dateradiation)
      : null,
    datedebcarte: participantData.datedebcarte
      ? dayjs(participantData.datedebcarte)
      : null,
    datefincarte: participantData.datefincarte
      ? dayjs(participantData.datefincarte)
      : null,
    date_deb_couverture: participantData.date_deb_couverture
      ? dayjs(participantData.date_deb_couverture)
      : null,
    date_fin_couverture: participantData.date_fin_couverture
      ? dayjs(participantData.date_fin_couverture)
      : null,
    date_deb_suspension: participantData.date_deb_suspension
      ? dayjs(participantData.date_deb_suspension)
      : null,
  };
  const formatLocalDateTime = (value) =>
    value ? dayjs(value).format("YYYY-MM-DDTHH:mm:ss") : null;

  const handleFormSubmit = async (values) => {
    try {
      // Fusionnez les valeurs existantes de participantData avec les nouvelles valeurs du formulaire
      const updatedValues = { ...participantData, ...values };

      // Construisez l'objet updatedParticipant avec toutes les valeurs du formulaire
      const encodedData = {
        ...updatedValues,
        datenaiss: updatedValues.datenaiss
          ? dayjs(updatedValues.datenaiss).format("YYYY-MM-DD")
          : null,
        dateemb: updatedValues.dateemb
          ? dayjs(updatedValues.dateemb).format("YYYY-MM-DD")
          : null,
        datesous: updatedValues.datesous
          ? dayjs(updatedValues.datesous).format("YYYY-MM-DD")
          : null,
        dateres: updatedValues.dateres
          ? dayjs(updatedValues.dateres).format("YYYY-MM-DD")
          : null,
        datecreationpart: formatLocalDateTime(updatedValues.datecreationpart),
        datefincarte: updatedValues.datefincarte
          ? dayjs(updatedValues.datefincarte).format("YYYY-MM-DD")
          : null,
        datedebcarte: updatedValues.datedebcarte
          ? dayjs(updatedValues.datedebcarte).format("YYYY-MM-DD")
          : null,
        dateradiation: updatedValues.dateradiation
          ? dayjs(updatedValues.dateradiation).format("YYYY-MM-DD")
          : null,
        date_deb_couverture: updatedValues.date_deb_couverture
          ? dayjs(updatedValues.date_deb_couverture).format("YYYY-MM-DD")
          : null,
        date_fin_couverture: updatedValues.date_fin_couverture
          ? dayjs(updatedValues.date_fin_couverture).format("YYYY-MM-DD")
          : null,
        pc_temporaire: updatedValues.pc_temporaire || false,
        nb_mois_couvert: updatedValues.nb_mois_couvert || null,
        date_deb_suspension: updatedValues.date_deb_suspension
          ? dayjs(updatedValues.date_deb_suspension).format("YYYY-MM-DD")
          : null,
        duree_suspension: updatedValues.duree_suspension || null,
        desc_suspension: updatedValues.desc_suspension || "",
      };

      const updatedParticipant = {
        // Construisez l'objet updatedParticipant avec les valeurs du formulaire encodées
        ...encodedData,
      };

      // Appel de la fonction updateListParticipant
      await participantsIpmService.updateListParticipant(updatedParticipant);
      const refreshedData = await participantsIpmService.getOneListParticipant(numcont);
      setParticipantData(refreshedData);
      //navigate("/participants");
      navigate(-1);
      message.success("Participant mis à jour avec succès !");
    } catch (error) {
      // Gérez les erreurs de manière appropriée
      message.error(
        `Erreur lors de la mise à jour du participant : ${error.message}`
      );
    }
  };

  const getEtatTagProps = (etat) => {
    switch (etat) {
      case "A":
        return { color: "#67f02e", label: "Actif" };
      case "S":
        return { color: "#ffa500", label: "Suspendu" };
      case "W":
        return { color: "#1890ff", label: "En attente" };
      case "R":
        return { color: "#e80202", label: "Résilié" };
      default:
        return { color: "#d9d9d9", label: "Non défini" };
    }
  };

  const getSocieteName = (codesoc) => {
    if (!codesoc || !adherentsList.length) {
      console.log("codesoc:", codesoc, "adherentsList length:", adherentsList.length);
      return codesoc || '';
    }
    const societe = adherentsList.find(adh => adh.codeadht === codesoc);
    console.log("Recherche societe pour codesoc:", codesoc, "Trouvée:", societe);
    return societe ? societe.intitule : codesoc;
  };

  const etatTag = getEtatTagProps(participantData.suspension_part);
  const societeName = getSocieteName(participantData.codesoc);

  return (
    <div style={{ borderRadius: '14px', boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)', padding: '20px', width: '100%', margin: '0 auto', backgroundColor: '#f6f8fb' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'linear-gradient(135deg, #0f2d52, #174a7a)', borderRadius: '12px', padding: '16px 20px', color: '#fff', marginBottom: 18 }}>
        <div>
          <div style={{ fontSize: '13px', opacity: 0.85 }}>Participant</div>
          <div style={{ fontSize: '20px', fontWeight: 700 }}>
            {participantData.numcont ? `N° ${participantData.numcont} · ${participantData.prenom || ''} ${participantData.nom || ''}` : 'Chargement...'}
          </div>
          <div style={{ fontSize: '13px', opacity: 0.9 }}>
            {societeName ? `${societeName}` : ''}
          </div>
        </div>
        <Space size={10} align="center">
          {participantData?.etat && (
            <Tag color={etatTag.color} style={{ padding: '4px 10px', borderRadius: 12, fontWeight: 600 }}>{etatTag.label}</Tag>
          )}
          <Link
            to="/participants"
            className="link-secondary"
            state={{ codesocFromPart: participantData.codesoc }}
          >
            <Button
              type="primary"
              shape="round"
              size="middle"
              icon={<ArrowLeftOutlined />}
            >
              Retour
            </Button>
          </Link>
        </Space>
      </div>

      <div style={{ background: '#fff', borderRadius: 12, padding: 18, border: '1px solid #e9edf3' }}>
        <Formulaire
          onSubmit={handleFormSubmit}
          initialValues={initialValuesWithMoment}
          matripart={participantData.numcont}
          familleData={familleData}
        />
      </div>
    </div>
  );
};

export default EditParticipant;
